import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {AddOrSetRenderHelper} from "./AddOrSetRenderHelper";

export function RenderUpsertAccountValues(props: RendererProps): ReactElement {
    return <AddOrSetRenderHelper {...props} />;
}